import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetexKeywordsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetexKeywordsQuery = { __typename?: 'Query', getexKeywords: Array<{ __typename?: 'GetexKeyword', id: string, name: string }> };


export const GetexKeywordsDocument = gql`
    query GetexKeywords {
  getexKeywords {
    id
    name
  }
}
    `;

/**
 * __useGetexKeywordsQuery__
 *
 * To run a query within a React component, call `useGetexKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexKeywordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetexKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<GetexKeywordsQuery, GetexKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexKeywordsQuery, GetexKeywordsQueryVariables>(GetexKeywordsDocument, options);
      }
export function useGetexKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexKeywordsQuery, GetexKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexKeywordsQuery, GetexKeywordsQueryVariables>(GetexKeywordsDocument, options);
        }
export type GetexKeywordsQueryHookResult = ReturnType<typeof useGetexKeywordsQuery>;
export type GetexKeywordsLazyQueryHookResult = ReturnType<typeof useGetexKeywordsLazyQuery>;
export type GetexKeywordsQueryResult = Apollo.QueryResult<GetexKeywordsQuery, GetexKeywordsQueryVariables>;